import { useState } from "react";
import PropTypes from "prop-types";
import ArrowUp from "shared/components/utils/icons/Up";
import ArrowDown from "shared/components/utils/icons/Down";
import { StyledButton } from "./ButtonsLayer.styles";

const ButtonsLayer = ({
    onClickArrowUp,
    onClickArrowDown,
    disableUp,
    disableDown,
    onUpdate,
    ...props
}) => {
    const [arrowClicked, setArrowClicked] = useState(false);

    const handleClicklArrowUp = (event) => {
        setArrowClicked(true);
        onClickArrowUp(event);
    };
    const handleClicklArrowDown = (event) => {
        setArrowClicked(true);
        onClickArrowDown(event);
    };

    const handleMouseLeave = (event) => {
        arrowClicked && onUpdate(event);
        setArrowClicked(false);
    };

    return (
        <div className={props.className}>
                <StyledButton
                    onClick={(event) => handleClicklArrowUp(event)}
                    disable={disableUp}
                    onMouseLeave={(event) => handleMouseLeave(event)}
                >
                    <ArrowUp hover={!disableUp} />
                </StyledButton>
                <StyledButton
                    onClick={(event) => handleClicklArrowDown(event)}
                    disable={disableDown}
                    onMouseLeave={(event) => handleMouseLeave(event)}
                >
                    <ArrowDown hover={!disableDown} />
                </StyledButton>
        </div>
    );
};

ButtonsLayer.propTypes = {
    onClickArrowUp: PropTypes.func.isRequired,
    onClickArrowDown: PropTypes.func.isRequired,
    disableUp: PropTypes.bool,
    disableDown: PropTypes.bool,
    onUpdate: PropTypes.func.isRequired,
    className: PropTypes.string,
};

export default ButtonsLayer;
